import { render, staticRenderFns } from "./download-the-form.vue?vue&type=template&id=1f7601e5"
import script from "./download-the-form.vue?vue&type=script&lang=js"
export * from "./download-the-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports